import { AutoComplete, AutoCompleteProps } from './autocomplete';
import { Input } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { ICustomer } from '../../../interfaces/customer';
import { mapCustomerItem } from '../../../utils/edit.constants';

export const AutocompleteCustomerInput = (props: Omit<AutoCompleteProps<ICustomer>, 'mapItem'>) => {
  return (
    <AutoComplete
      resource='api/v1/users'
      mapItem={mapCustomerItem}
      notFoundPlaceholder='Type in full name, user id, or email to search'
      {...props}
    >
      <Input placeholder='Customer' size='large' suffix={<DownOutlined />} />
    </AutoComplete>
  );
};
